<template>
  <DashboardPage>
    <PageBreadcrumb
      :crumbs="[{
        label: $t('subscriber.subscribers')
      }]"
    />

    <SpinningLoader :pending="pending">
      <div class="sm:container mx-2 sm:mx-auto">
        <AsteonlineCard
          v-for="subscriber in subscribers"
          :key="'subscribers-' + subscriber.uuid"
        >
          <CardHead>
            <UserGroupIcon class="h-4 w-4 mr-2 inline-block" />
            {{ subscriber.name }}
          </CardHead>

          <CardBody v-if="subscriber.address || subscriber.zip || subscriber.city || subscriber.province">
            <p v-if="subscriber.address">
              {{ subscriber.address }}
            </p>
            <p v-if="subscriber.zip || subscriber.city || subscriber.province">
              {{ subscriber.zip }} {{ subscriber.city }} <span v-if="subscriber.province">({{ subscriber.province }})</span>
            </p>
            <p v-if="subscriber.country">
              {{ subscriber.country }}
            </p>
          </CardBody>
        </AsteonlineCard>
      </div>
    </SpinningLoader>
  </DashboardPage>
</template>

<script setup>
import { UserGroupIcon } from '@heroicons/vue/24/solid';
import { ref } from 'vue'

import AsteonlineCard from '@/components/card/AsteonlineCard.vue';
import CardBody from '@/components/card/CardBody.vue';
import CardHead from '@/components/card/CardHead.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import SpinningLoader from '@/components/SpinningLoader.vue';
import useAxios from '@/composables/axios';

const axios = useAxios()

let pending = ref(true)
let subscribers = ref([])

axios.get('/affiliate/list').then((resp) => {
    subscribers.value = resp.data
    pending.value = false;
}).catch(() => {
});

</script>